/**
 * Event bridge for the plot dialogs (PLOT / PAGESETUP / PUBLISH), following
 * the DXF export bridge pattern: command runners dispatch requests,
 * ProjectDialogsHost mounts the components — neither side imports the other.
 */

export interface PlotDialogRequest {
    /** 'single' = plot one sheet; 'publish' = multi-layout batch. */
    mode: 'single' | 'publish';
    /** Preselected layout id (single mode); null = model space. */
    layoutId?: string | null;
    /** Publish source (Faz 10.13): 'layouts' = manual checkbox list,
     *  'sheetSet' = the document's sheet set (Include-for-Publish sheets). */
    source?: 'layouts' | 'sheetSet';
}

export interface PageSetupDialogRequest {
    /** Layout whose setup is edited; null = no layout active. */
    layoutId: string | null;
}

export const PLOT_DIALOG_EVENT = 'yap:open-plot-dialog';
export const PAGE_SETUP_DIALOG_EVENT = 'yap:open-pagesetup-dialog';

export function openPlotDialog(request: PlotDialogRequest = { mode: 'single' }): void {
    window.dispatchEvent(new CustomEvent(PLOT_DIALOG_EVENT, { detail: request }));
}

export function openPageSetupDialog(request: PageSetupDialogRequest): void {
    window.dispatchEvent(new CustomEvent(PAGE_SETUP_DIALOG_EVENT, { detail: request }));
}
